import { Box } from "@mui/material";
import FooterSection from "../components/FooterSection";
import Home from "../pages/Home";
import About from "./About";
import Contact from "./Contact";
import Products from "./Products";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function MainPage() {
  const location = useLocation();
 useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;

      requestAnimationFrame(() => {
        const section = document.getElementById(id);

        if (section) {
          const yOffset = -80;
          const y =
            section.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }

        window.history.replaceState({}, document.title);
      });
    }
  }, [location]);
  return (
    <>
      <Box id="home">
        <Home />
      </Box>
      <Box id="products">
        <Products />
      </Box>

      <Box id="about">
        <About />
      </Box>

      <Box id="contact">
        <Contact />
      </Box>

      <FooterSection />
    </>
  );
}
